import { defaultColors, xmodColorVars } from "../color-config";

export const defaultVesperColors = {
  ...defaultColors,
  ...xmodColorVars,
  "xmod-banner-tag-text": "#030F1E",
  "xmod-calendar-selected-date-background-border": "#030F1E",
  "xmod-calendar-unselected-date-border": "#D8DADC",
  "banner-root-text": "#030F1E",
  "banner-root-background": "#E2EDCC",
  "new-tag-background": "#030F1E",
  "button-primary-background": "#030F1E",
  "button-primary-hover-background": "#0A1929",
  "button-secondary-border": "#030F1E",
  "button-secondary-text": "#030F1E",
  "button-secondary-hover-background": "#0A1929",
  "button-book-background": "#030F1E",
  "button-critical-background": "#CC2427",
  "text-green-2": "#1F7D08",
  "green-1": "#1F7D08",
  "green-5": "#1F7D08",
  "xmod-free-cancellation-color": "#1F7D08",
  "bucket-1-color": "#D8DADC",
  "date-disabled-color": "#EDEEF0",
  "date-selected-price-text-color": "#0E1012",
  "primary-blue": "#030F1E",
  "algomerch-airline": "#CC2427",
  "algomerch-fareclass": "#030F1E",
  "floating-button-background": "#030F1E",
  "floating-button-border": "#030F1E",
  "floating-button-badge-background": "#CC2427",
  "earn-tag-text": "#030F1E",
  "expiration-tag-text": "#030F1E",
  "travel-credit-balance-card-background": "#030F1E",
  "icon-positive-background": "#1F7D08",
  "hotel-info-banner-background": "#1F7D08",
  "loading-modal-text": "#0E1012",
  "loading-modal-text-strong": "#0E1012",
  "loading-modal-heading-text": "#0E1012",
  "notification-banner-info-text": "#0E1012",
  "funnel-entry-tab-selected-background": "#030F1E",
  "light-spinner-blue": "#030F1E",
  "dark-spinner-blue": "#030F1E",
  "recently-viewed-tag-background": "#030F1E",
  "card-carousel-background": "#EDEEF0",
  "input-field-background": "#EDEEF0",
  "takeover-background-blue": "#EDEEF0",
  "action-button-active-background": "#030F1E",
  "action-link-active-text": "#030F1E",
  "price-prediction-gradient-red": "#CC2427",
  "banner-positive-text": "#1F7D08",
  "radio-button-primary-checked": "#030F1E",
  "green-6": "#1F7D08",
  "green-7": "#1F7D08",
  "blue-9": "#030F1E",
  "primary-text-grey": "#0E1012",
  "secondary-text-grey": "#666C72",
  "footer-section-background": "#F2F3F4",
  "earn-tag-background": "#EDEEF0",
  "primary-dark-blue": "#030F1E",
  "white-transparent": "rgba(255, 255, 255, 0.8)",
};
